// Fetch categories from the API
import instance from "../../utils/axios";

export const startCategoryTime = async (categoryID) => {
  try {
    if (!categoryID) {
      throw new Error("Category ID is required.");
    }
    return await instance.get(
      `/start-time-in-category/${encodeURIComponent(categoryID)}`
    );
  } catch (error) {
    console.error("Error fetching categories:", error.message);
    throw error; // Rethrow for further handling
  }
};
